export const AccountActivitiesTypes = {
    GET_ACC_ACTIVITIES:'GET_ACC_ACTIVITIES',
}